// extracted by mini-css-extract-plugin
export default {"heading":"media-alpha-options-module__heading--km2"};